/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { TestTermResultDetailDto } from '../models';
// @ts-ignore
import type { TestTermResultsResponseDto } from '../models';
/**
 * TestResultsApi - axios parameter creator
 * @export
 */
export const TestResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns an .xlsx file with the consolidated test results for the entire stage 2 of the certification (all participants, all terms). Intended for offline analysis / archive. 
         * @summary Export stage 2 (TEST) results as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStageTestResults: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('exportStageTestResults', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('exportStageTestResults', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/results/export`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed test execution result for a specific employee in a given test term. Includes per-question answers with correctness, question content, and timing. 
         * @summary Get test result detail for employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermResultDetail: async (certificationId: number, stageId: number, termId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermResultDetail', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermResultDetail', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermResultDetail', 'termId', termId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getTestTermResultDetail', 'employeeId', employeeId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/results/{employeeId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of test execution results for all participants in a given test term. Supports search by employee name (partial match). 
         * @summary Get test term results
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermResults: async (certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermResults', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermResults', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermResults', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/results`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestResultsApi - functional programming interface
 * @export
 */
export const TestResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns an .xlsx file with the consolidated test results for the entire stage 2 of the certification (all participants, all terms). Intended for offline analysis / archive. 
         * @summary Export stage 2 (TEST) results as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportStageTestResults(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportStageTestResults(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestResultsApi.exportStageTestResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns detailed test execution result for a specific employee in a given test term. Includes per-question answers with correctness, question content, and timing. 
         * @summary Get test result detail for employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermResultDetail(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermResultDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermResultDetail(certificationId, stageId, termId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestResultsApi.getTestTermResultDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of test execution results for all participants in a given test term. Supports search by employee name (partial match). 
         * @summary Get test term results
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermResults(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermResultsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermResults(certificationId, stageId, termId, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestResultsApi.getTestTermResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestResultsApi - factory interface
 * @export
 */
export const TestResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestResultsApiFp(configuration)
    return {
        /**
         * Returns an .xlsx file with the consolidated test results for the entire stage 2 of the certification (all participants, all terms). Intended for offline analysis / archive. 
         * @summary Export stage 2 (TEST) results as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStageTestResults(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportStageTestResults(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed test execution result for a specific employee in a given test term. Includes per-question answers with correctness, question content, and timing. 
         * @summary Get test result detail for employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermResultDetail(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermResultDetailDto> {
            return localVarFp.getTestTermResultDetail(certificationId, stageId, termId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of test execution results for all participants in a given test term. Supports search by employee name (partial match). 
         * @summary Get test term results
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermResults(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermResultsResponseDto> {
            return localVarFp.getTestTermResults(certificationId, stageId, termId, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestResultsApi - interface
 * @export
 * @interface TestResultsApi
 */
export interface TestResultsApiInterface {
    /**
     * Returns an .xlsx file with the consolidated test results for the entire stage 2 of the certification (all participants, all terms). Intended for offline analysis / archive. 
     * @summary Export stage 2 (TEST) results as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApiInterface
     */
    exportStageTestResults(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Returns detailed test execution result for a specific employee in a given test term. Includes per-question answers with correctness, question content, and timing. 
     * @summary Get test result detail for employee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApiInterface
     */
    getTestTermResultDetail(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermResultDetailDto>;

    /**
     * Returns paginated list of test execution results for all participants in a given test term. Supports search by employee name (partial match). 
     * @summary Get test term results
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name (partial match)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApiInterface
     */
    getTestTermResults(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermResultsResponseDto>;

}

/**
 * TestResultsApi - object-oriented interface
 * @export
 * @class TestResultsApi
 * @extends {BaseAPI}
 */
export class TestResultsApi extends BaseAPI implements TestResultsApiInterface {
    /**
     * Returns an .xlsx file with the consolidated test results for the entire stage 2 of the certification (all participants, all terms). Intended for offline analysis / archive. 
     * @summary Export stage 2 (TEST) results as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApi
     */
    public exportStageTestResults(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return TestResultsApiFp(this.configuration).exportStageTestResults(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed test execution result for a specific employee in a given test term. Includes per-question answers with correctness, question content, and timing. 
     * @summary Get test result detail for employee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApi
     */
    public getTestTermResultDetail(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return TestResultsApiFp(this.configuration).getTestTermResultDetail(certificationId, stageId, termId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of test execution results for all participants in a given test term. Supports search by employee name (partial match). 
     * @summary Get test term results
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name (partial match)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultsApi
     */
    public getTestTermResults(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig) {
        return TestResultsApiFp(this.configuration).getTestTermResults(certificationId, stageId, termId, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }
}

